export default "// Use this if you dont want annoying cmd popups\n$ npm install -g pm2@3.0.2\n\n// OR\n$ npm install -g pm2@latest\n";